import { useState, useEffect } from "react";
import { Box, InputAdornment, Typography, Container } from "@mui/material";
import {
  ResetButton,
  SearchButton,
  BniLoaderBox,
  MyConnectionsContainer,
  MyConnectionsSearchContainer,
  MyConnectionsSearchBox,
  MyConnectionsSearchFieldBox,
  MyConnectionsSearchField,
  MyConnectionsSearchMinCharError,
  MyConnectionsSearchActionsBox,
} from "./MyConnections.styles";
import { ReactComponent as SearchIcon } from "../../assests/icons/search_icon.svg";
import { connectionsApiUrl, testimonialsApiUrl } from "../../utils/config";
import CardsScrollableContainer from "../../components/CardsScrollableContainer";
import { useDispatch, useSelector } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import { useTranslation } from "react-i18next";
import { useDeleteRequests, usePostRequests } from "../../utils/queries";
import MyConnectionDetailDialog from "../../components/Dialog/MyConnectionDetailDialog";
import RequestsDialog from "../../components/Dialog/RequestsDialog";
import {
  ConnectionsToken,
  RequestsToken,
  ErrorToken,
  homeToken,
} from "../../utils/constant";
import InfoMessage from "../../components/Dialog/InfoMessage";
import InputDialogBox from "../../components/Dialog/InputDialogBox";
import { useSearchParams } from "react-router-dom";
import ScrollContainerWrapper from "../../components/ScrollContainerWrapper";
import ConnectionsCardsInfiniteScroll from "../../components/ConnectionsCardsInfiniteScroll";
import BniLoader from "../../components/Loaders/BniLoader";

const MyConnections = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let [searchParams, setSearchParams] = useSearchParams();
  const dialogType = useSelector((state) => state.dialog.dialogType);
  const requestId = useSelector((state) => state.dialog.requestId);
  const slectedUserData = useSelector((state) => state.dialog.dataObj);
  const deleteConnection = useDeleteRequests();
  const sendTestimonialMessage = usePostRequests();
  const [searchField, setSearchField] = useState("");
  const [searchFieldError, setSearchFieldError] = useState("");
  const [isMakeCall, setIsMakeCall] = useState(false);

  const searchFieldChangeHandler = (e) => {
    setSearchParams({});
    setSearchField(e.target.value);
    setSearchFieldError(false);
  };

  const handleSearchBtn = () => {
    let trimSearchField = searchField.trim();
    if (trimSearchField !== "" && trimSearchField.length >= 3) {
      setIsMakeCall(false);
      setSearchParams({
        search: `${trimSearchField}`,
      });
      setTimeout(() => {
        setIsMakeCall(true);
      }, 100);
    } else {
      setSearchFieldError(true);
    }
  };

  const handleResetBtn = () => {
    setSearchParams({});
    setSearchField("");
    setSearchFieldError(false);
    setIsMakeCall(false);
    setTimeout(() => {
      setIsMakeCall(true);
    }, 100);
  };

  const deleteConnectionHandler = () => {
    setIsMakeCall(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    if (requestId !== 0) {
      deleteConnection.mutate(
        {
          url: `${connectionsApiUrl}delete/connection/${requestId}`,
        },
        {
          mutationKey: "deleteConnectionRequest",
          onSuccess: (success) => {
            if (success.status === 200) {
              dispatch(dialogActions.setDialogType("successdeleteconnection"));
              dispatch(dialogActions.setDataObj({}));
              dispatch(dialogActions.setRequestId(0));
              setIsMakeCall(true);
              setTimeout(() => {
                dispatch(dialogActions.setDialogType(""));
              }, 2000);
            } else {
              dispatch(dialogActions.setDialogType("faileddeleteconnection"));
              dispatch(dialogActions.setIsDialogEnabled(true));

              setTimeout(() => {
                dispatch(dialogActions.setDialogType("myconnectiondetailcard"));
              }, 2000);
            }
          },
          onError: (error) => {
            console.log(" request delete failed ", error);
            alert(t(homeToken.GenericError));
          },
        }
      );
    } else {
      alert("Invalid delete id");
    }
  };

  const GiveorAskTestimonialHandler = (message) => {
    // type should be either 'give' or 'request' for api call
    const type =
      dialogType === "givetestimonial"
        ? "give"
        : dialogType === "asktestimonial"
        ? "request"
        : "";
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    if (requestId !== 0 && type !== "") {
      sendTestimonialMessage.mutate(
        {
          url: `${testimonialsApiUrl}${requestId}/${type}`,
          data: {
            recommendationBody: message,
          },
        },
        {
          mutationKey: "giveOrAskTestimonial",
          onSuccess: (success) => {
            if (success.status === 200) {
              dispatch(dialogActions.setDataObj({}));
              dispatch(dialogActions.setRequestId(0));
              dispatch(dialogActions.setDialogType(""));
              setIsMakeCall(true);
            } else {
              dispatch(dialogActions.setIsDialogEnabled(true));
              dispatch(dialogActions.setDialogType("myconnectiondetailcard"));
            }
          },
          onError: (error) => {
            console.log(" request delete failed ", error);
            alert(t(homeToken.GenericError));
          },
        }
      );
    } else {
      alert("Invalid delete id");
    }
  };

  useEffect(() => {
    const searchParamsValue = searchParams.get("search");
    if (searchParamsValue) {
      if (searchParamsValue.length >= 3) {
        setSearchField(searchParamsValue);
      } else {
        setSearchFieldError(true);
        setSearchField(searchParamsValue);
        return;
      }
    }
    setIsMakeCall(true);
  }, []);

  const firstName = () => {
    const name = slectedUserData && slectedUserData.name.split(" ");
    return name[0].toUpperCase();
  };

  return (
    <ScrollContainerWrapper>
      <MyConnectionsContainer>
        <Box>
          <MyConnectionsSearchContainer>
            <MyConnectionsSearchBox>
              <MyConnectionsSearchFieldBox>
                <MyConnectionsSearchField
                  placeholder={t(homeToken.Search)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className="search-ico" />
                      </InputAdornment>
                    ),
                  }}
                  value={searchField}
                  onChange={searchFieldChangeHandler}
                  onKeyDown={(e) => {
                    e.key === "Enter" && handleSearchBtn();
                  }}
                />
                <MyConnectionsSearchMinCharError
                  searchFieldError={searchFieldError}
                >
                  {t(ErrorToken.SearchLenghtError)}
                </MyConnectionsSearchMinCharError>
              </MyConnectionsSearchFieldBox>
              <MyConnectionsSearchActionsBox>
                <Box>
                  <SearchButton
                    title={t(homeToken.Search)}
                    onClick={handleSearchBtn}
                    disableRipple
                  >
                    {t(homeToken.Search)}
                  </SearchButton>
                </Box>
                <Box>
                  <ResetButton
                    title={t(homeToken.Reset)}
                    onClick={handleResetBtn}
                    disableRipple
                  >
                    {t(homeToken.Reset)}
                  </ResetButton>
                </Box>
              </MyConnectionsSearchActionsBox>
            </MyConnectionsSearchBox>
          </MyConnectionsSearchContainer>
        </Box>

        <CardsScrollableContainer marginTop={"false"} calcHeight="74vh">
          {isMakeCall ? (
            <ConnectionsCardsInfiniteScroll
              querykey="myconnections"
              searchText={searchField.trim()}
            />
          ) : (
            <BniLoaderBox>
              <BniLoader width="inherit" />
            </BniLoaderBox>
          )}
        </CardsScrollableContainer>

        {dialogType === "myconnectiondetailcard" && (
          <Container maxWidth="false" disableGutters>
            <MyConnectionDetailDialog />
          </Container>
        )}

        {dialogType === "deleteconnection" && (
          <Container maxWidth="false" disableGutters>
            <RequestsDialog
              dialogTitle={t(ConnectionsToken.DeleteConnection)}
              dialogContent={t(ConnectionsToken.DeleteMyConnections)}
              leftBtnVal={t(homeToken.Delete)}
              rightBtnVal={t(homeToken.Cancel)}
              leftbuttonHandler={deleteConnectionHandler}
            />
          </Container>
        )}
        {dialogType === "faileddeleteconnection" && (
          <Container maxWidth="false" disableGutters>
            <InfoMessage>
              <Typography sx={{ fontSize: "2.4rem", color: "#cf2030" }}>
                {t(ErrorToken.DeleteMyConnectionFailed)}
              </Typography>
            </InfoMessage>
          </Container>
        )}
        {dialogType === "successdeleteconnection" && (
          <Container maxWidth="false" disableGutters>
            <InfoMessage sx={{ with: "693px" }}>
              <Typography sx={{ fontSize: "2.4rem", color: "#cf2030" }}>
                {t(RequestsToken.DeleteRequestSuccessMessage)}
              </Typography>
            </InfoMessage>
          </Container>
        )}
        {(dialogType === "givetestimonial" ||
          dialogType === "asktestimonial") && (
          <Container maxWidth="false" disableGutters>
            <InputDialogBox
              dialogTitle={
                dialogType === "givetestimonial"
                  ? t(ConnectionsToken.GiveTestimonialDialogTitle, {
                      0: firstName(),
                    })
                  : t(ConnectionsToken.AskTestimonialDialogTitle, {
                      0: firstName(),
                    })
              }
              leftBtnVal={t(homeToken.Submit)}
              rightBtnVal={t(homeToken.Cancel)}
              leftbuttonHandler={GiveorAskTestimonialHandler}
            />
          </Container>
        )}
      </MyConnectionsContainer>
    </ScrollContainerWrapper>
  );
};

export default MyConnections;
